import dynamic from 'next/dynamic';
import { IntlRfpHeaderProps } from './IntlRfpHeader.types';

export const IntlRfpHeader = dynamic<{ model: IntlRfpHeaderProps }>(() =>
  import('./IntlRfpHeader').then(mod => mod.IntlRfpHeader)
);
